import { create } from "zustand";
import { IChannel } from "../models/channel";

type TChannelStore = {
  channels: IChannel[];
  channel?: IChannel;
  setCurrentChannel: (payload: IChannel) => void;
  setChannelList: (payload: IChannel[]) => void;
};

const useChannelStore = create<TChannelStore>((set) => ({
  channel: undefined,
  channels: [],
  setCurrentChannel: (payload: IChannel) => {
    set({
      channel: payload,
    });
  },
  setChannelList: (payload: IChannel[]) => {
    set({ channels: payload });
  },
}));

export default useChannelStore;
